import axios from 'axios'
import {simpleRequest} from "../apiConfigs/request";

export const fetchSignedUrl = (data) => {
  return simpleRequest({
    url: '/public/signedurl',
    method: 'POST',
    data
  })
}

export const uploadDocumentToS3 = (url, data, contentType) => {
  return axios({
    method: 'put',
    url: url,
    headers: { 'Content-Type': contentType },
    data,
    withCredentials: false
  });
}
